import { createPinia } from 'pinia'
import app from './Vue/app';
import RetailLocator from '@components/RetailLocator.vue';
import RetailResults from '@components/RetailResults.vue';

const pinia = createPinia()
app.use(pinia);

app.component('RetailLocator', RetailLocator);
app.component('RetailResults', RetailResults);
